































































import { Component, Vue } from 'vue-property-decorator'
import PageHeader from '@/components/public/PageHeader.vue'
import '../../styles/home.less'
import router from '@/router'
import homeApi from '@/api/homeApi'
import $ from 'jquery'
import ShowImg from '@/components/ui/ShowImg.vue'

@Component({
  components: {
    ShowImg
  }
})
export default class Home extends Vue {
  private list: any = []
  private goodsId: string = ''
  private btnList: boolean = false
  private scrollTop: number = 0
  private floorList: any = [
    {      createTimestamp: 20190111,
      enable: false,
      id: 3,
      link: 'www.baidu.com',
      name: '广告专区',
      positionRespVO: {
        advertisementRespVOList: {

        },
        businessType: 'PROMOTION',
        carousel: false,
        createTimestamp: 20190111,
        description: 'buzhidao',
        emptySku: 3,
        enabled: true,
        height: 12,
        id: 9527,
        name: 'dog',
        position: '大屏幕',
        promotionRespVOList: '广告',
        skus: 9,
        state: false,
        updateTimestamp: 20190111,
        width: 66
      },
      sort: 1,
      updateTimestamp: 20190111
    }
  ]
  private carouselList: any = []

  public mounted(): void {
    window.addEventListener('scroll', this.handleScroll)
    this.protected()
    this.getCarouselList()
    // router.push({ name: 'goods-list', query: { resourceType: '陈列测试' } });
  }

  public destroyed(): void {
    window.removeEventListener('scroll', this.handleScroll)
  }

  // 获取轮播数据
  protected getCarouselList(): void {
    homeApi.getCarousel({
      businessType: 'ADVERTISEMENT',
      position: 'HOME_BANNER'
    }).then((res) => {
      if (res.code === 200) {
        this.carouselList = res.data.advertisementRespVOList
      }
    })
  }

  // 获取首页数据
  protected protected(): void {
    homeApi.getHome().then((res) => {
      if (res.code === 200) {
        this.floorList = res.data
      }
    })
  }


  // 楼层
  protected toFloor(item: any) {
    // document.getElementById(item.positionId).scrollIntoView()
    let scroll = document.documentElement.scrollTop
    let el = document.getElementById(item.id).offsetTop
    let step = el / 100;
    if (el > scroll) {
      smoothDown()
    } else {
      let newel = scroll - el
      step = newel / 50
      smoothUp()
    }
    // 内容大于滚轮向下走
    function smoothDown() {
      if (scroll < el) {
        scroll += step
        document.body.scrollTop = scroll
        document.documentElement.scrollTop = scroll
        setTimeout(smoothDown, 10)
      } else {
        document.body.scrollTop = el
        document.documentElement.scrollTop = el
      }
    }
    // 滚轮大于内容向上
    function smoothUp() {
      if (scroll > el) {
        scroll -= step
        document.body.scrollTop = scroll
        document.documentElement.scrollTop = scroll
        setTimeout(smoothUp, 10)
      } else {
        document.body.scrollTop = el
        document.documentElement.scrollTop = el
      }
    }
  }

  // 获取滚轮
  protected handleScroll() {
    this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    if (this.scrollTop > 250) {
      this.btnList = true
    } else {
      this.btnList = false
    }
  }

  // 返回顶部
  protected backTop() {
    let top = window.scrollY;
    let time = setInterval(() => {
      top = top - 50;
      window.scrollTo(0, top);
      if (top <= 0) {
        clearInterval(time);
      }
    }, 10)
  }

  // 到详情页
  protected goGoodsDetails(goods: any) {
    if (goods.jumpAddress) {
      // window.location.href = goods.jumpAddress
      window.open(goods.jumpAddress)
    } else {
      this.$router.push({ name: 'goods-details', query: { id: goods.id } })
    }
  }

  // 点击轮播
  protected handCarouse(item: any) {
    if (item.jumpAddress) {
      // window.location.href = item.jumpAddress
      window.open(item.jumpAddress)
    } else {
      this.$router.push({ name: 'goods-details', query: { id: item.id } })
    }
  }

  // 点击更多跳转列表
  protected goGoodsList(item: any) {
    if (item.link) {
      // window.location.href = item.link
      window.open(item.link)
    } else {
      this.$router.push({ name: 'goods-list', query: { keyword: item.name } })
    }
  }
}
